// extracted by mini-css-extract-plugin
module.exports = {"newUIMenuWrapper":"DetailsInnerHeader__newUIMenuWrapper--I2j","newUIMenuContainer":"DetailsInnerHeader__newUIMenuContainer--2ZK","active":"DetailsInnerHeader__active--1C5"};